import router from '../config/router'
import store from '../config/store'
import AuthorizationError from './../error/AuthorizationError'

const successLogin = function (authenticationData) {
  localStorage.setItem('token', authenticationData.token)
  localStorage.setItem('user', JSON.stringify(authenticationData.user))
  setupAuth()
  redirectToDefaultOrLastRoute()
}

const logout = function () {
  localStorage.removeItem('token')
  localStorage.removeItem('user')
  store.commit('security/authentication/AUTHENTICATION_SET_DATA', {token: null, user: null})
}

const setupAuth = function () {

  const token = localStorage.getItem('token')
  let user = localStorage.getItem('user')

  if (token && user) {
    user = JSON.parse(user)
    store.commit('security/authentication/AUTHENTICATION_SET_DATA', {token, user})
    store.dispatch('config/config/loadConfig')
  } else {
    logout()
  }
}
const isUserLogin = function () {
  if (store.state.security.authentication.user !== null) {
    return true
  }
  return false
}

const checkPrivilege = function (role) {
  if (isUserLogin() && store.state.security.authentication.user.roles.indexOf(role) > -1) {
    return true
  }
  return false
}

const getToken = function () {
  return store.state.security.authentication.token
}

const handleAuthorizationError = function (exception) {

  if (exception instanceof AuthorizationError) {
    setLastRoute(router.history.current.path)
    logout()
    router.push({name: 'Login'})
    return true
  }
  return false
}

const setLastRoute = function (routeName) {
  if (routeName != null) {
    localStorage.setItem('lastRoute', routeName)
  }
}

const redirectToDefaultOrLastRoute = function () {
  if(!isUserLogin()){
    router.push({name: 'login'})
  }else{
    console.log('lastRoute',localStorage.getItem('lastRoute'));
    if(localStorage.getItem('lastRoute')){
      router.push({path: localStorage.getItem('lastRoute')})
      localStorage.removeItem('lastRoute')
    } else {
      router.push({path: '/customers'})
    }
  }
}

export default {
  successLogin,
  logout,
  setupAuth,
  checkPrivilege,
  isUserLogin,
  getToken,
  handleAuthorizationError,
  setLastRoute,
  redirectToDefaultOrLastRoute,
}



// WEBPACK FOOTER //
// ./src/utils/security.js